import { Navigate } from 'react-router-dom';
import { getAuth } from 'firebase/auth';
import { useEffect, useState } from 'react';
import { Hearts } from 'react-loader-spinner';

const PrivateRoute = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(null);
    const auth = getAuth();

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            setIsAuthenticated(!!user);
        });

        return () => unsubscribe();
    }, [auth]);

    if (isAuthenticated === null) {
        // Show a loading spinner or skeleton screen while checking auth state
        return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><Hearts height="80" width="80" color="#f97316" ariaLabel="hearts-loading" visible={true} /></div>;
    }

    return isAuthenticated ? children : <Navigate to="/auth" />;
};

export default PrivateRoute;